/**
 * Generic segment keys for the progress meter (stacked bar).
 * Order in config determines left-to-right order in the bar.
 */
export type ProgressSegmentKey = 'completed' | 'inProgress' | 'outstanding';

/**
 * Configuration for one segment of the progress meter.
 */
export interface GroupedProgressSegmentConfig {
    key: ProgressSegmentKey;
    label: string;
    color: string;
}

export interface GroupedProgressConfig {
    /** Title above the section (e.g. "Department Progress", "Progress by Role"). */
    title: string;
    /** Subtitle below the title (e.g. "Progress by Department"). */
    subtitle?: string;
    /** Segment definitions in display order (left to right). */
    segments: GroupedProgressSegmentConfig[];
}

export const DEFAULT_GROUPED_PROGRESS_CONFIG: GroupedProgressConfig = {
    title: 'Progress',
    segments: [
        { key: 'completed', label: 'Completed', color: '#22c55e' },
        { key: 'inProgress', label: 'In Progress', color: '#f97316' },
        { key: 'outstanding', label: 'Not Started', color: '#6b7280' },
    ],
};
